import React, { useState, useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { BACKEND } from "../config/configEnvs";

const EditarTarea = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [tarea, setTarea] = useState("");
  const [fechaLimite, setFechaLimite] = useState("");
  const [marca, setMarca] = useState("");

  useEffect(() => {
    const fetchTarea = async () => {
      try {
        const response = await axios.get(
          `${BACKEND}/api/tareas/${id}`
        );
        const tarea = response.data;
        setTarea(tarea.tarea || "");
        setFechaLimite(tarea.fecha_limite || "");
        setMarca(tarea.marca || "");
      } catch (error) {
        console.error("Error al obtener el tarea:", error);
      }
    };

    if (id) {
      fetchTarea();
    }
  }, [id]);

  const handleTareaChange = (e) => {
    setTarea(e.target.value);
  };

  const handleFechaLimiteChange = (event) => {
    setFechaLimite(event.target.value);
  };

  const handleMarcaChange = (e) => {
    setMarca(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.put(
        `${BACKEND}/api/tareas/${id}`,
        {
          tarea,
          fecha_limite: fechaLimite,
          marca,
        }
      );

      const tareaActualizado = response.data;
      console.log("Tarea actualizado:", tareaActualizado);
      navigate("/home/tareas");
    } catch (error) {
      console.error("Error al actualizar el tarea:", error);
    }
  };

  return (
    <div className="flex items-center justify-center mt-12">
      <div className="bg-white rounded-lg p-8 shadow-md w-full max-w-md">
        <h2 className="text-2xl mb-4">Editar Tarea</h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-4 flex items-center">
            <label htmlFor="filtroFechaLimite" className="block mr-4">
              Fecha límite:
            </label>
            <input
              type="date"
              id="filtroFechaLimite"
              name="filtroFechaLimite"
              value={fechaLimite}
              onChange={handleFechaLimiteChange}
              className="w-40"
              required
            />
          </div>
          <div className="mb-4">
            <label htmlFor="name" className="block mb-2">
              Nombre
            </label>
            <input
              type="text"
              id="tarea"
              value={tarea}
              onChange={handleTareaChange}
              className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:border-blue-500"
              required
            />
          </div>
          <div className="mb-4">
            <label htmlFor="marca" className="block mb-2">
              Marca
            </label>
            <input
              type="text"
              id="marca"
              value={marca}
              onChange={handleMarcaChange}
              className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:border-blue-500"
              required
            />
          </div>
          <div className="flex justify-end">
            <Link
              to="/home/tareas"
              type="button"
              className="px-4 py-2 mr-2 bg-gray-200 rounded"
              onClick={() => {
                console.log("Cancelado");
              }}
            >
              Cancelar
            </Link>
            <button
              type="submit"
              className="px-4 py-2 bg-[#ff6400] rounded text-white"
            >
              Actualizar
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditarTarea;
